import { HostBinding, ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SwatchComponentDef } from '@df/catalog-ui/product/swatch/swatch.component.def';

/**
 * You can pass either option or value + attributeCode pair
 *
 * IMPORTANT: width is required! See below
 *
 * <swatch [option]="option" [style.width.px]="20"></swatch>
 * <swatch [value]="colorValue" attributeCode="color" [style.width.px]="20"></swatch>
 */
@Component({
    selector: 'swatch',
    templateUrl: './swatch.html',
    styleUrls: ['./swatch.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwatchComponent extends SwatchComponentDef {
    @Input()
    @HostBinding('class.disabled')
    disabled = false;

    get swatch(): string {
        if (this.option && typeof this.option !== 'string') {
            return this.option.swatch || '';
        }
        return '';
    }
}
